import { billingService } from './billing';

/** An active plan is a paid period that covers right now. Free and expired do not count. */
export const hasActivePaidPlan = (plan) => plan?.status === 'active';

/**
 * Dashboard is only for an active paid plan. Anything else stays on the requested path.
 * A billing lookup failure is treated as unpaid.
 */
export async function destinationAfterPlanCheck(path = '/dashboard') {
  if (path !== '/dashboard') return path;
  try {
    const data = await billingService.getMyBilling();
    return hasActivePaidPlan(data?.plan) ? '/dashboard' : '/pricing';
  } catch {
    return '/pricing';
  }
}
